export var pillContentStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    return Object.assign({
      fontSize: v.contentFontSize,
      padding: v.contentPadding,
      alignSelf: 'center'
    }, p.size === 'small' && {
      fontSize: v.contentFontSizeSmall,
      padding: v.contentPaddingSmall
    }, p.size === 'smaller' && {
      fontSize: v.contentFontSizeSmaller,
      padding: v.contentPaddingSmaller
    }, p.actionable && {
      paddingRight: 0
    });
  }
};
//# sourceMappingURL=pillContentStyles.js.map
